import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
  onIdTokenChanged,
  reload,
  sendPasswordResetEmail,
  signInWithCustomToken,
  RecaptchaVerifier,
} from "firebase/auth";

import {
  doc,
  setDoc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  documentId,
  onSnapshot,
  serverTimestamp,
  updateDoc,
  addDoc,
  deleteDoc,
  orderBy,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  getDownloadURL,
  uploadString,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { PAYMENT_HOST, STATUS } from "../common/constants";
import axios from "axios";
import algoliasearch from "algoliasearch/lite";
import { utils, writeFileXLSX } from "xlsx";
import { useEffect, useState, useCallback } from "react";
import { generateCategory } from "../utils/utils";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

export const firebaseConfig = {
  apiKey: "AIzaSyAUL4pKi27JiVWxmrrxtGrU-jQQ2H4Re7A",
  authDomain: "oyun-5302a.firebaseapp.com",
  projectId: "oyun-5302a",
  storageBucket: "oyun-5302a.appspot.com",
  messagingSenderId: "236315289548",
  appId: "1:236315289548:web:5dc34ddca033eab61c9f69",
  measurementId: "G-5K25JWN90F",
};

const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);
export const db = getFirestore(firebaseApp);
const storage = getStorage();

const appCheck = initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaV3Provider("6LeBsFMpAAAAAPMSAJfLSeZMKks1pkZKNYyfv98v"),
  isTokenAutoRefreshEnabled: true, // Set to true to allow auto-refresh.
});
// const appCheck = initializeAppCheck(firebaseApp, {
//   provider: new ReCap("6Lf94lMpAAAAABnALfA9uZLHj2z4IH5OAwONBJxN"),
//   isTokenAutoRefreshEnabled: true, // Set to true to allow auto-refresh.
// });
export const createAuthUser = async (email, pass, season) => {
  let user = {};
  const auth = getAuth();
  user = await createUserWithEmailAndPassword(auth, email, pass)
    .then((res) => {
      sendVerificationEmail(res.user);
      setDoc(
        doc(db, "users", res.user.uid),
        { email, registration_season: season },
        { merge: true }
      );

      return res.user;
    })
    .catch((error) => {
      // console.log("signup error", error);
      if (error.code === "auth/email-already-in-use")
        alert(
          "Bu e-posta adresi ile daha önce kayıt yapılmış. Lütfen Giriş ekranından şifreniz ile giriş yapınız."
        );
    });
  return user;
};

export const listenUserAuthState = (userSetter) => {
  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    userSetter(user);
  });
};

// export const listenEmailVerificationStatus = (userSetter) => {
//   const auth = getAuth();
//   onIdTokenChanged(auth, (user) => {
//     console.log("id token değişti!!");
//     console.log("firebase methods listeneer verified user:", user);
//     userSetter(user);
//   });

// }

export const fbLogout = async (uid) => {
  const auth = getAuth();
  await writeTokenToDb(uid, 0);

  signOut(auth).then(
    function () {
      // Sign-out successful.
    },
    function (error) {
      alert("Logut esnasında hata oldu: ", error);
    }
  );
};

export const fbLogin = async (mail, pass) => {
  // firebase authentiocaton kullanarak kişinin o kişi olduğunu teyid ettikten sonra cloud sql'den kişiye ait detaylı bilgi çekeceğiz.
  const auth = getAuth();
  let res = "-";
  let isError = false;
  const userCredential = await signInWithEmailAndPassword(
    auth,
    mail,
    pass
  ).catch((error) => {
    isError = true;
    if (error.code === "auth/wrong-password") {
      res = "wrong_pass";
    } else {
      res = "email_not_found";
    } // Hatalara saçma sapan kodlar veriyorum ki hata bildiren kullanıcılar ekran görüntüsü attığında doğrudan kaynağı bulalım :)
  });

  if (!isError) {
    res = userCredential.user;
  }
  return res;
};

export const loginWithMasterPass = async (
  email,
  pass,
  userSetter,
  isLoggedInByOriginalPassFunc
) => {
  // Süper şifre ile tüm hesaplara login olunabilir. Süper şifrenin ilk karakterleri oyunsüper, ama devamı da var, bu şifre firebase functions içinde config var olarak kayıtlı
  // Şifrenin ilk kısmı oyunsüper ise, email-şifre cloud functions'a gönderiliyor, orada şifrenin tamamı doğru mu diye kontrol ediliyor.
  // Şifre doğruysa cloud functions bir auth token üreterek client'a gönderiyor. Client bu tokeni kullanarak login oluyor.

  // const response = await axios.post('http://localhost:5001/oyun-5302a/us-central1/loginWithMasterPass',
  const response = await axios.post(
    "https://us-central1-oyun-5302a.cloudfunctions.net/loginWithMasterPass",
    {
      email,
      pass,
    }
  );
  // console.log("response of master pass", response);

  const token = response.data.token;
  // console.log("client tarafında alınan token:", token);
  const auth = getAuth();
  const userCredential = await signInWithCustomToken(auth, token).catch((e) => {
    alert("master sifre hata var: ", e.message);
  });
  let user = userCredential.user;
  userSetter(user);
  isLoggedInByOriginalPassFunc(false);
};

export const pullUserData = async (uid) => {
  const u = await getDoc(doc(db, "users", uid)).catch((e) => {
    // console.log(e);
    alert("Bilgileriniz çekilirken hata meydana geldi!");
  }); // bu doküman yoksa bile u objesi geliyor, ama u.data() undefined oluyor.
  if (u && u.data()) {
    return { ...u.data(), uid: u.id };
  } else return null;
};

// Giriş sırasında kullanılır. Okuma hata verirse birkaç kez tekrar dener ve
// hatayı "doküman yok" durumundan ayırır; böylece veri çekilemediğinde
// kullanıcıya boş profil formu gösterilmez.
export const pullUserDataWithRetry = async (uid, attempts = 3) => {
  let lastError;
  for (let i = 0; i < attempts; i++) {
    try {
      const u = await getDoc(doc(db, "users", uid));
      return {
        data: u.exists() ? { ...u.data(), uid: u.id } : null,
      };
    } catch (e) {
      lastError = e;
      await new Promise((resolve) => setTimeout(resolve, 1000 * (i + 1)));
    }
  }
  return {
    data: null,
    error: {
      code: lastError?.code || "unknown",
      message: lastError?.message || String(lastError),
      time: new Date().toLocaleString("tr-TR"),
    },
  };
};

export const saveUserData = async (uid, data) => {
  await setDoc(doc(db, "users", uid), data, { merge: true });
};
export const updateExamInfo = async (productId, examIndex, data) => {
  const productRef = doc(db, "products", productId);
  const productSnap = await getDoc(productRef);
  if (productSnap.exists()) {
    const productData = productSnap.data();
    if (productData.exams && productData.exams[examIndex]) {
      productData.exams[examIndex] = {
        ...productData.exams[examIndex],
        ...data,
      };
      await updateDoc(productRef, { exams: productData.exams });
      return "Sınav bilgileri başarıyla güncellendi!";
    } else {
      return "Belirtilen sınav bulunamadı.";
    }
  } else {
    return "Belirtilen ürün bulunamadı.";
  }
};

export const fetchActiveProduct = async (userRole) => {
  let qry = "";
  if (userRole === "developer")
    qry = query(
      collection(db, "products"),
      where("is_developer_active", "==", true)
    );
  else qry = query(collection(db, "products"), where("is_active", "==", true));
  const querySnapshot = await getDocs(qry);
  let activeProducts = [];
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    let product = doc.data();
    product.id = doc.id;
    if (product.payment_start_at)
      product.payment_start_at = product.payment_start_at.toDate();
    if (product.payment_end_at)
      product.payment_end_at = product.payment_end_at.toDate();

    activeProducts.push(product);
  });

  if (activeProducts?.length === 0) return null;
  else if (activeProducts?.length === 1) return activeProducts[0];
  else {
    // console.log("HATA. Aktif ürünler: ", activeProducts);
    alert(
      "Aynı anda birden fazla aktif ürün olmamalı. Lütfen verileri kontrol ediniz!"
    );
    return null;
  }
};

export const getPayment = async (paymentToken) => {
  // const response = await axios.post( PAYMENT_HOST + 'payments/check', { payment_token: paymentToken});
  const response = await axios.post(
    PAYMENT_HOST + "receipts/check_purchase_with_payment_token",
    { payment_token: paymentToken }
  );
  // console.log("response.data:", response);

  return response?.data; //?.status === "successful";
};

export const getPaymentUrl = async (params) => {
  const response = await axios.post(
    PAYMENT_HOST + "receipts/get_payment_url_for_oyun",
    { ...params }
  );
  // console.log("response.data:", response);

  return response?.data;
};

export const markPaymentAsSuccessful = async (userId, productId) => {
  const newData = {
    products: {
      [productId]: {
        is_paid: true,
        paid_at: serverTimestamp(),
      },
    },
  };
  await saveUserData(userId, newData);
  return true;
};

export const sendVerificationEmail = (usr) => {
  const options = {
    url: window.location.origin + "/profile",
  };

  // console.log("options", options);

  const userForVerify = usr ? usr : getAuth().currentUser;
  // console.log("verification user:", userForVerify);
  sendEmailVerification(userForVerify, options).then(() => {
    // alert("Lütfen e-posta kutunuza giderek doğrulama linkine tıklayınız.");
  });
  // auth.user.sendEmailVerification().then(()=>{
  //   alert("Lütfen e-posta kutunuza giderek doğrulama linkine tıklayınız.");
  // });
  // sendEmailVerification(auth.user);
};

export const reloadAuthData = async (oldUser, setCentralState) => {
  let auth = getAuth();
  // reload(auth.currentUser);
  await auth.currentUser.reload();
  auth = getAuth();
  const currentUser = auth.currentUser;
  setCentralState({ user: { ...oldUser, ...currentUser } });
  if (!currentUser.emailVerified) {
    sendVerificationEmail(currentUser);
    alert("E-posta adresinizie doğrulama linki gönderilmiştir.");
  }
};

export const requestPasswordReset = (email) => {
  const auth = getAuth();
  return sendPasswordResetEmail(auth, email)
    .then(() => {
      return (
        email +
        " adresinize şifre sıfırlama linki gönderildi. Gelen kutunuzu kontrol ediniz."
      );
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      // console.log("errorCode:", errorCode);
      return "HATA: Sıfırlama maili gönderilemedi.";
    });
};

export const searchUsers = async (api_key, queryString) => {
  // Api key'i user tablosuna ekledim. Environment variable olmadığı için.
  const client = algoliasearch("UAEOGKAK5A", api_key);
  const index = client.initIndex("email_name_phone");

  const requestOptions = {
    // headers: { 'X-Algolia-UserToken': 'user123' }
  };

  let response = await index.search(queryString, requestOptions);
  // .then(({ hits }) => {
  //   console.log("HİTS: ", hits);
  // });
  return response?.hits || [];
};

export const adminChangesUserData = async (params) => {
  const { userId, competitorNewPass, emailVerified, newEmail } = params;
  let auth = getAuth();
  // const response = await axios.post('http://localhost:5001/oyun-5302a/us-central1/adminChangesUserData',

  if (!userId) {
    alert("HATA: User Id bilgisi verilmemiş!");
    return null;
  } else {
    let bodyParams = {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      cookies: {}, // TODO: Buraya ne gelecek bilmiyorum. Cookie'de saklanan değer varsa onu kullan gibi bir şey olacak galiba.
      competitorUid: userId,
      ...params,
    };

    const response = await axios.post(
      "https://us-central1-oyun-5302a.cloudfunctions.net/adminChangesUserData",
      bodyParams
    );
    if (response.status === 200) return response.data.result;
    else return "HATA: Bilgiler güncellenirken birşeyler ters gitti.";
  }
};

export const verifyEmailManually = async (userId) => {
  let auth = getAuth();
  // const response = await axios.post('http://localhost:5001/oyun-5302a/us-central1/adminVerifiesUser',
  const response = await axios.post(
    "https://us-central1-oyun-5302a.cloudfunctions.net/adminVerifiesUser",
    {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      cookies: {},
      competitorUid: userId,
    }
  );
  if (response.status === 200) return response.data.result;
  else return "HATA: e-posta doğrulaması yapılırken birşeyler ters gitti.";
};

export const readStats = async () => {
  const stats = await getDoc(doc(db, "stats", "oyun2026"));
  return stats.data();
};

export const doSmth = async (params) => {
  // const qry = query(collection(db, "products"), where("is_active", "==", true));
  // const querySnapshot = await getDocs(qry);
  // let activeProducts = [];
  // querySnapshot.forEach((doc) => {
  //   // doc.data() is never undefined for query doc snapshots
  //   activeProducts.push(doc.data());
  // });
  // let data = {
  //   ...activeProducts[0]
  // };
  // const sampleids = [
  //   {
  //     birth_year_start: 0,
  //     birth_year_end: 1972,
  //     exam_id: "osisExamId",
  //     exam_questions_id: "osisExamQuestionsId"
  //   },
  //   {
  //     birth_year_start: 1973,
  //     birth_year_end: 2003,
  //     exam_id: "osisExamId",
  //     exam_questions_id: "osisExamQuestionsId"
  //   },
  //   {
  //     birth_year_start: 2004,
  //     birth_year_end: 2008,
  //     exam_id: "osisExamId",
  //     exam_questions_id: "osisExamQuestionsId"
  //   },
  //   {
  //     birth_year_start: 2009,
  //     birth_year_end: 2013,
  //     exam_id: "osisExamId",
  //     exam_questions_id: "osisExamQuestionsId"
  //   },
  //   {
  //     birth_year_start: 2014,
  //     birth_year_end: 2500,
  //     exam_id: "osisExamId",
  //     exam_questions_id: "osisExamQuestionsId"
  //   },
  // ];
  // data.exams[0].exam_access_ids = sampleids;
  // data.exams[1].exam_access_ids = sampleids;
  // data.exams[2].exam_access_ids = sampleids;
  // delete data.exams[0].exam_access_id;
  // delete data.exams[1].exam_access_id;
  // delete data.exams[2].exam_access_id;
  // setDoc(doc(db, "products", "oyun2022"), data)
  // getAllUsers();
  // insertResults();
  // getElemeSuccessfulEmails();
};

const markMultiplePaymentsAsSuccessful = async () => {
  const emails = [
    // "black-pearl6@hotmail.com",
    // "dumansevgi91@gmail.com",
    // "sevgiduran_26_1991@hotmail.com",
    // "alecgsfatih@hotmail.com",
    // "yucelgov@hotmail.com",
    // "burakdogan12@gmail.com",
    // "osmanihsan26@gmail.com",
    // "eteroglu@gmail.com",
    // "dr.comer@gmail.com",
    // "mnkrtl@gmail.com",
    // "aygulcal@hotmail.com",
    // "esracetinkayaengin@gmail.com",
    // "rusen2662@gmail.com",
    // "niyazi_uyar84@hotmail.com",
    // "melgoshnar@gmail.com",
    // "paramedik-d@hotmail.com",
    // "dt.didem@gmail.com",
    // "mandaciticaret@gmail.com",
    // "sekufe.kalkan@metu.edu.tr",
    // "hpolat1998@yahoo.com",
    // "defnebayatli2010@gmail.com",
    // "andincserap@gmail.com",
    // "kubrayuksel26@gmail.com",
    // "canyilmaz5361@hotmail.com",
    // "baykaloguzkaan@gmail.com",
    // "fatmasaglamlar@gmail.com",
    // "muzafferd@gmail.com",
    "mandaciengin26@gmail.com",
    // "hpolat@gmail.com",
    // "sekufekalkan26@gmail.com",
  ];

  let kayitsizlar = [];
  let ids = [];
  for (let i = 0; i < emails.length; i++) {
    const email = emails[i].trim();
    const qry = query(collection(db, "users"), where("email", "==", email));
    const querySnapshot = await getDocs(qry);
    if (querySnapshot.docs.length === 0) kayitsizlar.push(email);
    else {
      const docId = querySnapshot.docs[0].id;
      ids.push(docId);
      await markPaymentAsSuccessful(docId, "oyun2022");
    }
  }

  // console.log("kayitsizlar", kayitsizlar);
  // console.log("ids", ids);
};

export const getAllUsers = async () => {
  let users = [];
  const ss = await getDocs(query(collection(db, "users")));
  ss.docs.forEach((doc) => {
    let id = doc.id;
    let data = doc.data();
    users.push({
      id,
      ...data,
    });
  });
  return users;
};

const toNamePascalCase = (str) => {
  if (!str) return "";
  return str
    .split(" ")
    .map(
      (word) =>
        word.charAt(0).toLocaleUpperCase("tr-TR") +
        word.slice(1).toLocaleLowerCase("tr-TR")
    )
    .join(" ");
};

export const exportAllUsersToExcel = async () => {
  let productId = "oyun2026"; // TODO: aslında aktif sezonu otomatik çekmeli. Ya da bi dropdown'dan gelmeli
  let users = {
    rows: [],
  };
  const qry = query(collection(db, "users"));
  const ss = await getDocs(qry);
  ss.docs.forEach((doc) => {
    let id = doc.id;
    let data = doc.data();

    const row = {
      ID: id,
      "ADI-SOYADI": toNamePascalCase(data.name),
      EPOSTA: data.email,
      TELEFON: data.phone,
      "DOĞUM YILI": data.birth_year,
      ŞEHİR: data.city,
      EĞİTİM: data.education,
      CİNSİYET: data.gender,
      MESLEK: data.occupation,
      "ARAÇ PLAKASI": data.car_plate,
      "KAYIT SEZONU": data.registration_season,
      "22 ÖDEMESİ": data.products?.oyun2022?.is_paid ? "ÖDENDİ" : "",
      "23 ÖDEMESİ": data.products?.oyun2023?.is_paid ? "ÖDENDİ" : "",
      "24 ÖDEMESİ": data.products?.oyun2024?.is_paid ? "ÖDENDİ" : "",
      "25 ÖDEMESİ": data.products?.oyun2025?.is_paid ? "ÖDENDİ" : "",
      "26 ÖDEMESİ": data.products?.oyun2026?.is_paid ? "ÖDENDİ" : "",
      "Eleme Sınavı Sonucu": data.products?.oyun2025?.eleme_sonuc,
      "Eleme Sınavı Puanı": data?.products?.oyun2025?.eleme_puan,
      "Yarı Final Sınavı Sonucu": data.products?.oyun2025?.yf_sonuc,
      "Yarı Final Sınavı Puanı": data?.products?.oyun2025?.yf_puan,
      "Yarı Final Sınavı Ek Puanı": data?.products?.oyun2025?.yf_ekpuan,
      "Final Derecesi": data?.products?.oyun2026?.final_derecesi,
      "Belge Numarası": data?.products?.oyun2026?.file_number,
      "Toplam Puan": data?.products?.oyun2026?.total_score,
      "Toplam Sıralama": data?.products?.oyun2026?.total_rank,

      // "ELEME SIRASI": "",
      // "YARI FİNALE HAK KAZANDI MI": "YARI FİNALE HAK KAZANDI",
      // "YARI FİNAL SIRASI": "",
      // "FİNALE HAK KAZANDI MI?": "FİNALE HAK KAZANDI",
    };
    users.rows.push(row);
  });

  const ws = utils.json_to_sheet(users.rows);
  const wb = utils.book_new();
  utils.book_append_sheet(wb, ws, "Data");
  writeFileXLSX(wb, "Oyun Tüm Kullanıcılar.xlsx");

  return users;
};

// Sınavın gerçek (o sezona ait) doğum yılı aralıklarından kategori bulur.
// exam_access_ids bulunamazsa, geçmiş yıllara ait sabit generateCategory'e düşer.
export const getCategoryForBirthYear = (birthYear, examAccessIds) => {
  if (examAccessIds?.length > 0) {
    const match = examAccessIds.find(
      (a) => birthYear >= a.birth_year_start && birthYear <= a.birth_year_end
    );
    if (match?.category) return match.category;
  }
  return generateCategory(birthYear) || "";
};

// Eleme sonucunda Yarı Final aşamasına hak kazananların Excel listesi (uid, ad-soyad, email, kategori)
export const exportyfResultUsersToExcel = async (productId, examAccessIds) => {
  if (!productId) {
    alert("Aktif ürün bulunamadı, lütfen sayfayı yenileyip tekrar deneyin.");
    return [];
  }

  const qry = query(collection(db, "users"));
  const ss = await getDocs(qry);
  const rows = [];
  ss.docs.forEach((doc) => {
    const data = doc.data();
    if (data.products?.[productId]?.eleme_sonuc === 1) {
      rows.push({
        UID: doc.id,
        "ADI-SOYADI": toNamePascalCase(data.name),
        EPOSTA: data.email,
        "DOĞUM YILI": data.birth_year || "",
        KATEGORİ: getCategoryForBirthYear(data.birth_year, examAccessIds),
      });
    }
  });

  if (rows.length > 0) {
    const ws = utils.json_to_sheet(rows);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Yari Final Adaylari");
    writeFileXLSX(wb, "Yari Final Aday Listesi.xlsx");
  }

  return rows;
};

// Yarı Final sonucunda Final aşamasına hak kazananların Excel listesi (uid, ad-soyad, email, kategori)
export const exportFinalResultUsersToExcel = async (
  productId,
  examAccessIds
) => {
  if (!productId) {
    alert("Aktif ürün bulunamadı, lütfen sayfayı yenileyip tekrar deneyin.");
    return [];
  }

  const qry = query(collection(db, "users"));
  const ss = await getDocs(qry);
  const rows = [];
  ss.docs.forEach((doc) => {
    const data = doc.data();
    if (data.products?.[productId]?.yf_sonuc === 1) {
      rows.push({
        UID: doc.id,
        "ADI-SOYADI": toNamePascalCase(data.name),
        EPOSTA: data.email,
        "DOĞUM YILI": data.birth_year || "",
        KATEGORİ: getCategoryForBirthYear(data.birth_year, examAccessIds),
      });
    }
  });

  if (rows.length > 0) {
    const ws = utils.json_to_sheet(rows);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Final Adaylari");
    writeFileXLSX(wb, "Final Aday Listesi.xlsx");
  }

  return rows;
};

// Final aşamasına hak kazanıp araç plakası girmiş kullanıcıların plaka listesi (yalnızca plakalar, A-Z sıralı)
export const exportFinalCarPlatesToExcel = async (productId) => {
  if (!productId) {
    alert("Aktif ürün bulunamadı, lütfen sayfayı yenileyip tekrar deneyin.");
    return [];
  }

  const qry = query(collection(db, "users"));
  const ss = await getDocs(qry);
  const rows = [];
  ss.docs.forEach((doc) => {
    const data = doc.data();
    const carPlate = (data.car_plate || "")
      .toString()
      .trim()
      .toLocaleUpperCase("tr");
    if (data.products?.[productId]?.yf_sonuc === 1 && carPlate) {
      rows.push({ PLAKA: carPlate });
    }
  });

  const collator = new Intl.Collator("tr", {
    numeric: true,
    sensitivity: "base",
  });
  rows.sort((a, b) => collator.compare(a.PLAKA, b.PLAKA));

  if (rows.length > 0) {
    const ws = utils.json_to_sheet(rows);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Final - Plaka");
    writeFileXLSX(wb, "Final - Plaka Listesi.xlsx");
  }

  return rows;
};

// Sınav salonu atanmış kullanıcıların Excel listesi: önce salona, salon içinde ada göre (A-Z) sıralı
export const exportExamRoomUsersToExcel = async (productId, examAccessIds) => {
  if (!productId) {
    alert("Aktif ürün bulunamadı, lütfen sayfayı yenileyip tekrar deneyin.");
    return [];
  }

  const qry = query(collection(db, "users"));
  const ss = await getDocs(qry);
  const rows = [];
  ss.docs.forEach((doc) => {
    const data = doc.data();
    const examRoomInfo = (data.products?.[productId]?.exam_room_info || "")
      .toString()
      .trim();
    if (examRoomInfo) {
      rows.push({
        SALON: examRoomInfo,
        "ADI-SOYADI": toNamePascalCase(data.name),
        EPOSTA: data.email,
        TELEFON: data.phone || "",
        "DOĞUM YILI": data.birth_year || "",
        KATEGORİ: getCategoryForBirthYear(data.birth_year, examAccessIds),
        UID: doc.id,
      });
    }
  });

  // numeric: "12 Nolu Salon" < "105 Nolu Salon" olacak şekilde doğal sıralama
  const collator = new Intl.Collator("tr", {
    numeric: true,
    sensitivity: "base",
  });
  rows.sort(
    (a, b) =>
      collator.compare(a.SALON, b.SALON) ||
      collator.compare(a["ADI-SOYADI"] || "", b["ADI-SOYADI"] || "")
  );

  if (rows.length > 0) {
    const ws = utils.json_to_sheet(rows);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Final - Salon");
    writeFileXLSX(wb, "Final - Salon.xlsx");
  }

  return rows;
};

// Profil sayfasındaki "Sınav Ekranı" butonuyla aynı OSİS linkini üretir.
// Kategori bulunamazsa (doğum yılı aralık dışı / exam_id eksik) boş döner.
const buildOsisExamLink = (uid, name, birthYear, examAccessIds) => {
  const match = (examAccessIds || []).find(
    (a) => birthYear >= a.birth_year_start && birthYear <= a.birth_year_end
  );
  if (!match?.exam_id || !match?.exam_questions_id) return "";
  const nameForUrl = (name || "").trim().replaceAll(" ", "+");
  return (
    "https://sinav.tzv.org.tr/linkedExam/" +
    match.exam_id +
    "&" +
    match.exam_questions_id +
    "&" +
    uid +
    "&" +
    nameForUrl
  );
};

// Excel sheet adı kurallarına uydurur: en fazla 31 karakter, []:*?/\ yasak, benzersiz.
const toSafeSheetName = (name, usedNames) => {
  const cleaned = name.replace(/[[\]:*?/\\]/g, "-").trim() || "Salon";
  const base = cleaned.slice(0, 31).trim();
  let candidate = base;
  let i = 2;
  while (usedNames.has(candidate.toLocaleLowerCase("tr"))) {
    const suffix = ` (${i++})`;
    candidate = base.slice(0, 31 - suffix.length) + suffix;
  }
  usedNames.add(candidate.toLocaleLowerCase("tr"));
  return candidate;
};

const NO_ROOM_LABEL = "Salon Atanmamış";

// Final'e hak kazananların (yf_sonuc === 1) Final sınavı (exams[2]) linkleri.
// İlk sheet tüm liste, ardından her salon/sınıf için ayrı sheet; salon içinde ada göre (A-Z) sıralı.
export const exportExamLinksToExcel = async (productId, exams) => {
  if (!productId) {
    alert("Aktif ürün bulunamadı, lütfen sayfayı yenileyip tekrar deneyin.");
    return [];
  }

  const finalAccessIds = exams?.[2]?.exam_access_ids;

  const qry = query(collection(db, "users"));
  const ss = await getDocs(qry);
  const rows = [];
  ss.docs.forEach((doc) => {
    const data = doc.data();
    const productData = data.products?.[productId];
    if (productData?.yf_sonuc !== 1) return;

    rows.push({
      SALON: (productData.exam_room_info || "").toString().trim(),
      "ADI-SOYADI": toNamePascalCase(data.name),
      KATEGORİ: getCategoryForBirthYear(data.birth_year, finalAccessIds),
      "FİNAL SINAV LİNKİ": buildOsisExamLink(
        doc.id,
        data.name,
        data.birth_year,
        finalAccessIds
      ),
    });
  });

  // numeric: "12 Nolu Salon" < "105 Nolu Salon"; salonu olmayanlar en sonda
  const collator = new Intl.Collator("tr", {
    numeric: true,
    sensitivity: "base",
  });
  rows.sort(
    (a, b) =>
      !a.SALON - !b.SALON ||
      collator.compare(a.SALON, b.SALON) ||
      collator.compare(a["ADI-SOYADI"] || "", b["ADI-SOYADI"] || "")
  );

  if (rows.length > 0) {
    const buildSheet = (sheetRows) => {
      const ws = utils.json_to_sheet(sheetRows);
      ws["!cols"] = [{ wch: 25 }, { wch: 30 }, { wch: 15 }, { wch: 90 }];
      // Link hücrelerini Excel'de tıklanabilir yap (D sütunu, başlık satırı hariç)
      sheetRows.forEach((row, i) => {
        const link = row["FİNAL SINAV LİNKİ"];
        const cell = ws[utils.encode_cell({ r: i + 1, c: 3 })];
        if (link && cell) cell.l = { Target: link };
      });
      return ws;
    };

    const wb = utils.book_new();
    const usedNames = new Set();
    utils.book_append_sheet(
      wb,
      buildSheet(rows),
      toSafeSheetName("Tümü", usedNames)
    );

    const rowsByRoom = new Map();
    rows.forEach((row) => {
      const room = row.SALON || NO_ROOM_LABEL;
      if (!rowsByRoom.has(room)) rowsByRoom.set(room, []);
      rowsByRoom.get(room).push(row);
    });
    rowsByRoom.forEach((roomRows, room) => {
      utils.book_append_sheet(
        wb,
        buildSheet(roomRows),
        toSafeSheetName(room, usedNames)
      );
    });

    writeFileXLSX(wb, "Final - Sınav Linkleri.xlsx");
  }

  return rows;
};

export const getPublicUrlOfFile = async (path) => {
  let url = "";
  try {
    url = await getDownloadURL(ref(storage, path));
  } catch (error) {
    // console.log("------- Şu dosya yoluna erişim kısıtlanmış: ", path);
    // console.log("getPublicUrlOfFile error", error);
  }
  return url;
};

export const fetchFileFromUrl = async (url) => {
  if (!url) alert("HATA: Dosya yolu verilmedi!");

  let pom = document.createElement("a");
  pom.href = url;
  pom.target = "blank";
  pom.click();
};

function arrayToCsv(data, filename) {
  let content = data
    .map(
      (row) =>
        row
          .map(String) // convert every value to String
          .map((v) => v.replaceAll('"', '""')) // escape double colons
          .map((v) => v.replaceAll("undefined", ""))
          .map((v) => `"${v}"`) // quote it
          .join(",") // comma-separated
    )
    .join("\r\n"); // rows starting on new lines

  var blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  var url = URL.createObjectURL(blob);

  // Create a link to download it
  var pom = document.createElement("a");
  pom.href = url;
  pom.setAttribute("download", filename);
  pom.click();

  alert("indi");
}

const insertResults = async () => {
  // Verilen array'e göre sonuçları firebase'e yazar.

  let users = [["vlo27gLCcMVqfPP7SrFweVSm31T2", 45.0, 233]];

  let i = 1;
  for (const user of users) {
    const [uid, total_score, total_rank] = user;
    const data = {
      products: {
        oyun2025: {
          total_score,
          total_rank,
        },
      },
    };
    await saveUserData(uid, data);
    // if (i % 10 === 0) console.log(i + "/" + users.length);
    i++;
  }
};

const getElemeSuccessfulEmails = async () => {
  const allUsers = await getAllUsers();
  const emails = [];
  for (const user of allUsers) {
    const { email, products } = user;
    if (products?.oyun2023?.eleme_sonuc === 1) {
      emails.push(email);
    }
  }
  // console.log(emails);
  arrayToCsv(emails, "eleme_successful_emails.csv");
};

//Eleme sonucunda yarı finale hak kazananların listesi
export const getElemeSuccessfulEmailsYf = async () => {
  const allUsers = await getAllUsers();
  const emails = [];

  for (const user of allUsers) {
    const { email, products } = user;
    if (products?.oyun2024?.eleme_sonuc === 1) {
      emails.push(email);
    }
  }
  const csvContent = "data:text/csv;charset=utf-8," + emails.join("\n");
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "eleme_successful_emails.csv");
  document.body.appendChild(link);

  link.click();
};

//yarı final sonucunda finale kalanlar
export const getYfSuccessfulEmailsFn = async () => {
  const allUsers = await getAllUsers();
  const names = [];

  for (const user of allUsers) {
    const { name, products } = user;
    if (products?.oyun2024?.yf_sonuc === 1) {
      names.push(name);
    }
  }

  const bom = "\uFEFF"; // UTF-8 BOM
  const csvContent = bom + names.join("\n");
  const encodedUri = encodeURI("data:text/csv;charset=utf-8," + csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "Finalist Listesi.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getTopRankHolders = async (season) => {
  const queryOfRanks = query(
    collection(db, "users"),
    where(`products.${season}.final_derecesi`, "<=", 10)
  );
  const querySnapshot = await getDocs(queryOfRanks);
  let allUsers = [];
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    const user = doc.data();
    allUsers.push({
      name: user.name,
      birth_year: user.birth_year,
      medal: user.products[season].final_derecesi,
      uid: doc.id,
    });
  });
  return allUsers;
};

export const generateHallOfFames = async (season) => {
  const hallOfFameUsers = await getHallOfFameUsers(season);
  const topRankedUsers = await getTopRankHolders(season);

  for (const user of topRankedUsers) {
    const { uid } = user;
    const isUserInHOF = hallOfFameUsers.find((u) => u.uid === uid);
    if (!isUserInHOF) {
      const ref = doc(collection(db, "hall_of_fames"));

      await setDoc(
        ref,
        {
          user_id: uid,
          season: season,
          name: user.name,
          category: generateCategory(user.birth_year),
          medal: user.medal,
          result: `${generateCategory(user.birth_year)} ${STATUS[user.medal]}`,
        },
        { merge: true }
      );
    }
  }
};

export const getHallOfFameUsers = async (season) => {
  if (!season) {
    // console.log("Please provide a season name to get hall of fame users.");
    return [];
  }
  const queryOfHOF = query(
    collection(db, "hall_of_fames"),
    where("season", "==", season)
  );
  const querySnapshot = await getDocs(queryOfHOF);
  let allUHOFusers = [];
  querySnapshot.forEach((doc) => {
    allUHOFusers.push(doc.data());
  });
  return allUHOFusers;
};
// Her sezon ayrı dosya: aynı kişi birden fazla yıl kürsüye girerse eski yılın fotoğrafı ezilmesin
export const uploadImageToDb = async (file, uid, season) => {
  const storageRef = ref(
    storage,
    `2024_public/hall_of_fame/${uid}/${season}_profile.jpg`
  );
  const snapshot = await uploadString(storageRef, file, "base64");
  const starsRef = ref(storage, snapshot.ref.fullPath);
  const downloadURL = await getDownloadURL(starsRef);
  return downloadURL;
};

export const addAboutToDb = async (about, season, uid, photoURL) => {
  const queryOfHof = query(
    collection(db, "hall_of_fames"),
    where("season", "==", season),
    where("user_id", "==", uid)
  );
  const querySnapshot = await getDocs(queryOfHof);
  let hofDoc = querySnapshot?.docs?.[0];
  if (!hofDoc) {
    alert("Kullanıcı bulunamadı.");
    return;
  }
  let trimmedAboutString = about.slice(0, 100);
  trimmedAboutString = trimmedAboutString + "...";
  const ref = doc(db, "hall_of_fames", hofDoc.id);
  await setDoc(
    ref,
    {
      about: trimmedAboutString,
      about2: about,
      // Yeni fotoğraf yüklenmediyse mevcut fotoğraf korunur
      ...(photoURL ? { photo: photoURL } : {}),
    },
    { merge: true }
  );
};

export const getHallOfFameUser = async (season, uid) => {
  const queryOfHof = query(
    collection(db, "hall_of_fames"),
    where("season", "==", season),
    where("user_id", "==", uid)
  );
  const querySnapshot = await getDocs(queryOfHof);
  let hofDoc = querySnapshot?.docs?.[0];
  if (!hofDoc) {
    alert("Kullanıcı bulunamadı.");
    return;
  }
  return hofDoc.data();
};

export const writeTokenToDb = async (uid, token) => {
  const ref = doc(db, "users", uid);
  await setDoc(
    ref,
    {
      token_for_concurrent_logins: token,
    },
    { merge: true }
  );
};

export const getConcurrentLoginToken = async (uid) => {
  const ref = doc(db, "users", uid);
  const docSnap = await getDoc(ref);

  if (docSnap.exists()) {
    return docSnap.data().token_for_concurrent_logins;
  } else {
    // doc.data() will be undefined in this case
    // console.log("No such document!");
  }
};
export const uploadInstagramPhotoToDb = async (file, fileName) => {
  const storageRef = ref(storage, `instagram-photos/${fileName}`);
  const snapshot = await uploadString(storageRef, file, "base64");
  const starsRef = ref(storage, snapshot.ref.fullPath);
  const downloadURL = await getDownloadURL(starsRef);
  return downloadURL;
};

export const adminBulkUpdateElemeSonuc = async (productId, rows) => {
  const auth = getAuth();
  const response = await axios.post(
    "https://us-central1-oyun-5302a.cloudfunctions.net/adminBulkElemeSonucu",
    {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      productId,
      rows,
    }
  );
  return response.data;
};

export const adminBulkUpdateYfSonuc = async (productId, rows) => {
  const auth = getAuth();
  const response = await axios.post(
    "https://us-central1-oyun-5302a.cloudfunctions.net/adminBulkYfSonucu",
    {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      productId,
      rows,
    }
  );
  return response.data;
};

export const adminBulkUpdateExamRoomInfo = async (productId, rows) => {
  const auth = getAuth();
  const response = await axios.post(
    "https://us-central1-oyun-5302a.cloudfunctions.net/adminBulkExamRoomInfo",
    {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      productId,
      rows,
    }
  );
  return response.data;
};

export const impersonateUser = async (targetUid) => {
  const auth = getAuth();
  const response = await axios.post(
    "https://us-central1-oyun-5302a.cloudfunctions.net/impersonateUser",
    {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      targetUid,
    }
  );

  return response.data.token; // sadece token döndür, window.open'ı sil
};

// Final puanı girilmiş kullanıcılar (orderBy, alanı olmayan dokümanları zaten dışarıda bırakır)
export const getFinalPuanUsers = async (productId) => {
  const ss = await getDocs(
    query(
      collection(db, "users"),
      orderBy(`products.${productId}.final_puan`, "desc")
    )
  );
  return ss.docs.map((d) => {
    const data = d.data();
    return {
      uid: d.id,
      name: data.name,
      email: data.email,
      birth_year: data.birth_year,
      yf_sonuc: data.products?.[productId]?.yf_sonuc,
      final_puan: data.products?.[productId]?.final_puan,
      final_derecesi: data.products?.[productId]?.final_derecesi,
      phone: data.phone,
      odul_gonderilecek: data.products?.[productId]?.odul_gonderilecek,
      kargo_adresi: data.products?.[productId]?.kargo_adresi,
      kargo_teslim_alindi: data.products?.[productId]?.kargo_teslim_alindi,
    };
  });
};

// rows: [{ uid, final_puan }] — final_puan null ise puan silinir
export const adminSetFinalPuan = async (productId, rows) => {
  const auth = getAuth();
  const response = await axios.post(
    "https://us-central1-oyun-5302a.cloudfunctions.net/adminSetFinalPuan",
    {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      productId,
      rows,
    }
  );
  return response.data;
};

// rows: [{ uid, final_derecesi, category }] — kategori bazlı final dereceleri.
// İlk 10'lar Şeref Kürsüsü'ne (hall_of_fames) de senkronlanır.
export const adminSaveFinalRanks = async (productId, rows) => {
  const auth = getAuth();
  const response = await axios.post(
    "https://us-central1-oyun-5302a.cloudfunctions.net/adminSaveFinalRanks",
    {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      productId,
      rows,
    }
  );
  return response.data;
};

// rows: [{ uid, odul_gonderilecek }] — true olanlara profilde kargo adresi formu açılır
export const adminSetOdulGonderimi = async (productId, rows) => {
  const auth = getAuth();
  const response = await axios.post(
    "https://us-central1-oyun-5302a.cloudfunctions.net/adminSetOdulGonderimi",
    {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      productId,
      rows,
    }
  );
  return response.data;
};

// Sezonun Şeref Kürsüsü kayıtlarını ve kullanıcıların final_derecesi alanını siler
export const adminClearFinalRanks = async (productId) => {
  const auth = getAuth();
  const response = await axios.post(
    "https://us-central1-oyun-5302a.cloudfunctions.net/adminClearFinalRanks",
    {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      productId,
    }
  );
  return response.data;
};
